module.exports = __webpack_public_path__ + "static/media/TrojanArcher.2e703c64.jpg";